import * as React from 'react';
import { Baggage as BaggageRoot } from '../../../../../../CheckoutAdditionalService/components';
import { useTranslation } from 'react-i18next';
import { groupGdsSelectedServices } from '../utils';
import { BabyCarriage, MusicalInstrument, PetInHold } from '../../../../../../Icons';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';
import { useConfig } from '../../../../../../context';
const AggregatedBaggage = ({ segmentId, service, hideCard }) => {
    const { t } = useTranslation('BaggageService');
    const theme = useTheme('Checkout').ServicesAggregationPage;
    const { global: { servicesAvailable: { animal: animalAvailable } } } = useConfig();
    const icons = [BabyCarriage, MusicalInstrument];
    if (!animalAvailable) {
        icons.push(PetInHold);
    }
    const selectedServices = groupGdsSelectedServices(service);
    return (React.createElement(BaggageRoot, { segmentId: segmentId, aggregationMode: true, totalPrice: service.totalPrice, minPrice: service.minPrice, isSelected: !!service.selectedServices.length, aggregationIcons: icons, className: cn({
            [theme.hideServiceCard]: hideCard
        }) }, selectedServices.map(service => {
        return (React.createElement("div", { key: service.service.rfics },
            service.service.name,
            ", ",
            service.service.value.amount,
            " ",
            t(service.service.value.measurement),
            " -",
            ' ',
            service.count,
            " ",
            t('pcs.')));
    })));
};
export default AggregatedBaggage;
